
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import CreateBusinessTab from "@/components/business/CreateBusinessTab";
import { BusinessDetails } from "@/types/index";

const CreateBusiness = () => {
  const navigate = useNavigate();

  const handleBusinessCreated = (newBusiness: BusinessDetails) => {
    // Navigate to dashboard after successful business creation
    navigate("/dashboard");
  };

  return (
    <div className="h-screen w-full bg-background">
      <Navbar hideBusinessNavigation={true} />
      <main className="w-full min-h-main-content">
        <div className="w-full h-full mx-auto p-4">
          <CreateBusinessTab onBusinessCreated={handleBusinessCreated} />
        </div>
      </main>
    </div>
  );
};

export default CreateBusiness;
